export default "__VITE_ASSET__3Htoz87C__"